import { ViewStyle } from 'react-native';

type SideSafeAreaInsets = {
	left: number;
	right: number;
};

export const getSafeAreaSidePadding = (
	sideInsets: SideSafeAreaInsets,
	extraPadding = 0,
): ViewStyle | null => {
	if (sideInsets.left <= 0 && sideInsets.right <= 0) {
		return null;
	}

	return {
		paddingLeft: sideInsets.left + extraPadding,
		paddingRight: sideInsets.right + extraPadding,
	};
};

export const getInsetAdjustedOffset = (inset: number, baseOffset: number) =>
	Math.max(0, inset) + baseOffset;
